import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, FormControl, Modal, Spinner, Table } from "react-bootstrap";
import {
  downloadEnquiry,
  enquiry,
} from "../../../store/actions/councilActions/enquiryAction";
import BreadCrumb from "../../BreadCrumb";
import Pagination from "../../misc/Pagination";
import { getCourseList } from "../../../store/actions/councilActions/courseAction";
import ReactPaginate from "react-paginate";
import AssignCenters from "../Common/AssignCenters";
import { getAssignments } from "../../../store/actions/councilActions/queryAssignAction";
const breadcrumbs = [
  {
    path: "/admin/dashboard",
    label: "Dashboard",
  },
  {
    label: "Admission Enquiry",
  },
];
const AdmissionEnquiry = () => {
  const { admin } = useSelector((state) => state);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [activePage, setactivePage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [course, setCourse] = useState("");
  const [courseName, setCourseName] = useState("");
  const [date, setDate] = useState("");
  const [search, setSearch] = useState("");
  const [viewRow, setViewRow] = useState(null); // enquiry shown in the details modal
  // Which centers each enquiry on this page is already with, and the row the
  // Assign box is open for.
  const [assigned, setAssigned] = useState({});
  const [assignFor, setAssignFor] = useState(null);

  const { courses } = admin;

  useEffect(() => {
    if (!courses) {
      dispatch(getCourseList());
    }
  }, []);

  const fetchData = useCallback(async () => {
    const response = await dispatch(
      enquiry("admission", activePage, course, date, search)
    );
    if (response) {
      setData(response.data);
      setLoading(false);
      settotalPages(Math.ceil(response.total / response.per_page));

      // One request for the whole page rather than one per row.
      const ids = (response.data || []).map((row) => row.id);
      if (ids.length) {
        setAssigned(await dispatch(getAssignments("enquiry", ids)));
      } else {
        setAssigned({});
      }
    } else {
      setLoading(false);
    }
  }, [activePage, dispatch, course, date, search]);

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [fetchData]);

  const handleDownload = () => {
    dispatch(downloadEnquiry("admission", course, date));
  };

  const handleReset = () => {
    setCourse("");
    setactivePage(1);
    setDate("");
    setSearch("");
  };

  return (
    <div>
      <div class="subheader py-2 py-lg-6 subheader-solid" id="kt_subheader">
        <div class="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
          <BreadCrumb crumbs={breadcrumbs} />

          <div class="d-flex align-items-center">
            <button
              onClick={handleDownload}
              className="btn btn-light-primary font-weight-bolder btn-sm"
            >
              Download list
            </button>
            <Link
              to="/admin/enquiry/affiliation"
              class="btn btn-light-primary font-weight-bolder btn-sm"
            >
              Affiliation Enquiry
            </Link>
          </div>
        </div>
        <div className="container">
          <div className=" mb-4">
            <div className="row">
              <div className="col-md-4">
                <FormControl
                  type="search"
                  placeholder="Search name, mobile, email, city, message..."
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                    setactivePage(1);
                  }}
                />
              </div>
              <div className="col-md-3">
                <select
                  class="form-control"
                  onChange={(e) => {
                    setCourse(e.target.value);
                    setCourseName(
                      e.target.selectedOptions[0].getAttribute("name")
                    );
                    setactivePage(1);
                  }}
                  value={course}
                  required
                >
                  <option value="">Select</option>
                  {courses &&
                    courses.map((course) => (
                      <option
                        key={course.name}
                        value={course.id}
                        name={course.name}
                      >
                        {course.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="col-md-3">
                <FormControl
                  type="date"
                  value={date}
                  onChange={(e) => {
                    setDate(e.target.value);
                    setactivePage(1);
                  }}
                ></FormControl>
              </div>
              <div className="col-md-2">
                <Button type="reset" onClick={handleReset}>
                  Reset
                </Button>
              </div>
            </div>
          </div>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" role="status" size="lg">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <Table bordered hover striped responsive className="mb-0">
              <thead>
                <th>S No</th>
                <th>Date</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Course</th>
                <th>Details</th>
                <th>Assigned Centers</th>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center text-danger">
                      No Record Found
                    </td>
                  </tr>
                ) : (
                  data.map((e, index) => (
                    <tr>
                      <td>{(activePage - 1) * 10 + index + 1}</td>
                      <td>
                        {e.created_at
                          ? moment(e.created_at).format("DD/MM/YYYY")
                          : "--"}
                      </td>
                      <td>{e.name}</td>
                      <td>{e.mobile}</td>
                      <td>{e.course?.name}</td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-sm btn-light-primary"
                          onClick={() => setViewRow(e)}
                        >
                          View
                        </button>
                      </td>
                      <td>
                        {/* which centers this enquiry has been passed to */}
                        <div class="mb-1">
                          {(assigned[e.id] || []).length === 0 ? (
                            <span class="text-muted">Not assigned</span>
                          ) : (
                            (assigned[e.id] || []).map((c) => (
                              <div key={c.center_id} class="mb-1">
                                <span class="badge badge-info mr-1">
                                  {c.center_code || c.center_name}
                                </span>
                                {/* what the center reported back */}
                                {c.outcome === "admitted" ? (
                                  <small class="text-success">
                                    Admitted
                                    {c.admission_date
                                      ? ` ${moment(c.admission_date).format(
                                          "DD/MM/YYYY"
                                        )}`
                                      : ""}
                                  </small>
                                ) : c.outcome === "not_admitted" ? (
                                  <small
                                    class="text-danger"
                                    title={c.reason || ""}
                                  >
                                    Not admitted
                                  </small>
                                ) : (
                                  <small class="text-muted">Pending</small>
                                )}
                              </div>
                            ))
                          )}
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-light-primary"
                          onClick={() => setAssignFor(e)}
                        >
                          Assign
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          )}
          {totalPages && Number(totalPages) !== 0 ? (
            <ReactPaginate
              className="pagination mt-5 justify-content-center"
              previousClassName="page-item"
              nextClassName="page-item"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              nextLinkClassName="page-link"
              previousLinkClassName="page-link"
              activeClassName="active"
              //   marginPagesDisplayed={10}
              onPageChange={(e) => setactivePage(e.selected + 1)}
              pageCount={totalPages}
              forcePage={activePage - 1}
              // renderOnZeroPageCount={null}
            />
          ) : null}
        </div>
      </div>

      <Modal show={!!viewRow} onHide={() => setViewRow(null)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Enquiry Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {viewRow && (
            <table className="table table-bordered mb-0">
              <tbody>
                <tr><th style={{ width: "35%" }}>Date</th><td>{viewRow.created_at ? moment(viewRow.created_at).format("DD/MM/YYYY hh:mm A") : "--"}</td></tr>
                <tr><th>Name</th><td>{viewRow.name || "--"}</td></tr>
                <tr><th>Mobile</th><td>{viewRow.mobile || "--"}</td></tr>
                <tr><th>Email</th><td>{viewRow.email || "--"}</td></tr>
                <tr><th>Course</th><td>{viewRow.course?.name || "--"}</td></tr>
                <tr><th>Address</th><td>{viewRow.address || "--"}</td></tr>
                <tr><th>City</th><td>{viewRow.city || "--"}</td></tr>
                <tr><th>State</th><td>{viewRow.state || "--"}</td></tr>
                <tr><th>Message</th><td>{viewRow.message || "--"}</td></tr>
              </tbody>
            </table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setViewRow(null)}>Close</Button>
        </Modal.Footer>
      </Modal>

      <AssignCenters
        show={!!assignFor}
        onHide={() => setAssignFor(null)}
        source="enquiry"
        queryId={assignFor?.id}
        label={
          assignFor
            ? `${assignFor.name || "Enquiry"} - ${assignFor.mobile || ""}`
            : ""
        }
        current={assignFor ? assigned[assignFor.id] : []}
        onSaved={(id, list) => setAssigned((a) => ({ ...a, [id]: list }))}
      />
    </div>
  );
};

export default AdmissionEnquiry;
